import { AvatarGroup, Text } from "@sundae/ui-toolkit";
import { ITextProps } from "@sundae/ui-toolkit/dist/types/components/atoms/Text/Text";
import { FC, ReactNode } from "react";
import { Asset } from "../../gql/generated/stats2.sdk";
import AssetAvatar, { IAssetAvatarProps } from "../AssetAvatar/AssetAvatar";

interface IAssetWithAssetNameProps extends Omit<IAssetAvatarProps, "asset"> {
  assetName: ReactNode;
  assets: [Asset, Asset] | Asset;
  assetNameWeight?: ITextProps["weight"];
  assetNameSize?: ITextProps["size"];
  assetNameVariant?: ITextProps["variant"];
}
const AssetWithAssetName: FC<IAssetWithAssetNameProps> = ({
  assetName,
  assets,
  assetNameWeight = "normal",
  assetNameSize = "sm",
  assetNameVariant = "normal",
  size = "sm",
  ...assetAvatarProps
}) => {
  const isAvatarGroup = Array.isArray(assets);

  return (
    <div className="flex items-center gap-2">
      {isAvatarGroup ? (
        <AvatarGroup>
          {assets.map((asset, index) => {
            return (
              <AssetAvatar
                {...assetAvatarProps}
                key={`${asset.assetId}-${index}`}
                asset={asset}
                size={size}
                stacked
              />
            );
          })}
        </AvatarGroup>
      ) : (
        <AssetAvatar {...assetAvatarProps} asset={assets} size={size} />
      )}

      {typeof assetName === "string" ? (
        <Text tag="span" size={assetNameSize} weight={assetNameWeight} variant={assetNameVariant}>
          {assetName}
        </Text>
      ) : (
        assetName
      )}
    </div>
  );
};

export default AssetWithAssetName;
